import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResourceService } from '../../generics/services/generic-http.service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { DevicePushToken } from '../models/device-push-token.model';

@Injectable({ providedIn: 'root' })
export class DevicePushTokenService extends ResourceService<DevicePushToken> {

  constructor(private http: HttpClient) {
    super(http, DevicePushToken, environment.apiUri + "/DevicePushToken");
  }

  public getAll<T>(): Observable<T[]> {
    return this.http
      .get<T[]>(this.apiUrl + "/all");
  }

  public getByUserID<T>(userID: number): Observable<T[]> {
    return this.http
      .get<T[]>(this.apiUrl + `/user/${userID}`);
  }

  public deleteByToken<T>(token: string): Observable<T[]> {
    return this.http
      .delete<T[]>(this.apiUrl + `/token/${token}`);
  }


}
